import { Editor, Transforms } from 'slate';
import { isCodeSnippetActive } from './utils';
import { type EditorPlugin } from '../../../types/aha-editor';
import CodeSnippetComponentPlugin from './CodeSnippetComponentPlugin';
import MarkdownPlugin from '../../MarkdownPlugin/MarkdownPlugin';
import { isCodeSnippetElement } from '../../../types/guards';
import NodeUtils from '../../../AhaEditorUtils/NodeUtils';
import { markdownRegexpForMark } from '../../MarkdownPlugin/MarkdownUtils';

export const CodeSnippetMarkdownPlugin: EditorPlugin = {
  name: 'Code snippet markdown plugin',
  dependencies: [MarkdownPlugin, CodeSnippetComponentPlugin],
  markdown: [
    {
      type: 'element',
      regex: markdownRegexpForMark('`'),
      triggerCharacter: '`',
      convert: (editor, options) => {
        Editor.insertNode(editor, {
          type: 'code-snippet',
          children: [{ text: options.plainText }],
        });
        Editor.insertNode(editor, {
          text: '',
        });
        Transforms.move(editor, { unit: 'offset' });
      },
      revert: (editor) => {
        const { selection } = editor;
        if (!selection) return;

        const codeSnippet = NodeUtils.previousSibling(
          editor,
          selection.anchor.path,
          {
            match: isCodeSnippetElement,
          }
        );

        if (codeSnippet) {
          Transforms.removeNodes(editor, {
            at: codeSnippet[1],
          });
        }
      },
      shiftTabRevert: false,
      test: (editor) => !isCodeSnippetActive(editor),
    },
  ],
};

export default CodeSnippetMarkdownPlugin;
